// Package imports:
import React from 'react';
import cx from 'classnames';

export type LabelTypes = 'osvarad' | 'engin' | 'litil' | 'undir-medallagi' | 'midlungs' | 'yfir-medallagi' | 'mikil' | 'einstaklingur' | 'logadili';

interface IProps {
    text: string | React.ReactNode,
    labelType: LabelTypes,
};

const MifidLabel: React.FC<IProps> = ({
    text,
    labelType,
}) => {
    return (
        <div className={cx('KCL_mifidLabel', `${labelType}-label`)}>
            <span>
                {text}
            </span>
        </div>
    );
}

export default MifidLabel;